import cn from 'classnames'

export const mergePropsWithClassName = <T extends { className?: string }>(
  props: T,
  ...className: string[]
) =>
  ({
    ...props,
    className: cn(props?.className, className),
  }) satisfies T
